// src/kafka/events.ts
var Events = /* @__PURE__ */ ((Events2) => {
  Events2["Identity"] = "event_identity";
  Events2["NewAccount"] = "new account";
  Events2["AppInstalled"] = "app installed";
  Events2["AppUninstalled"] = "app uninstalled";
  Events2["PaymentApproved"] = "payment approved";
  Events2["AppEnabled"] = "app enabled";
  Events2["AppDisabled"] = "app disabled";
  Events2["PaymentReceived"] = "payment received";
  Events2["StoreDetailsChanged"] = "store details changed";
  Events2["PrePaymentNextClick"] = "pre-payment: next click";
  Events2["OnboardingStarted"] = "onboarding started";
  Events2["OnboardingWelcomePageClick"] = "onboarding: welcome page click";
  Events2["OnboardingGoToDashboardClick"] = "onboarding: go to dashboard click";
  Events2["OnboardingWidgetTypePageView"] = "onboarding: widget type page view";
  Events2["OnboardingWidgetTypeSelected"] = "onboarding: widget type selected";
  Events2["OnboardingMaxDiscountPageView"] = "onboarding: max discount page view";
  Events2["OnboardingMaxDiscountSelected"] = "onboarding: max discount selected";
  Events2["OnboardingSetupPageView"] = "onboarding: setup page view";
  Events2["OnboardingSetupPageInternalClick"] = "onboarding: setup page internal click";
  Events2["OnboardingSetupPageNextClick"] = "onboarding: setup page next click";
  Events2["OnboardingExtensionPageView"] = "onboarding: extension page view";
  Events2["OnboardingExtensionPageClick"] = "onboarding: extension page click";
  Events2["OnboardingTryExtensionSetupClick"] = "onboarding: try extension setup click";
  Events2["OnboardingExtensionInstalled"] = "extension installed";
  Events2["OnboardingExtensionPanelOpened"] = "extension panel opened";
  Events2["OnboardingExtensionLaunchClick"] = "extension launch click";
  Events2["OnboardingExtensionPageSetupResult"] = "extension page setup result";
  Events2["OnboardingExtensionSetupCompleted"] = "extension setup completed";
  Events2["OnboardingExtensionGoToDashboardClick"] = "extension go to dashboard click";
  Events2["ShopifyEditorBannerClick"] = "shopify editor banner click";
  Events2["BackToOnboardingFromDashboard"] = "back to onboarding from dashboard";
  Events2["PageActivated"] = "page activated";
  Events2["PageDeactivated"] = "page deactivated";
  Events2["VariantCreated"] = "variant created";
  Events2["VariantEdited"] = "variant edited";
  Events2["VariantDeleted"] = "variant deleted";
  Events2["NewConversion"] = "new conversion";
  Events2["InternalReviewCollectorViewed"] = "internal review collector viewed";
  Events2["InternalReviewCollectorClicked"] = "internal review collector clicked";
  Events2["InternalReviewSubmitted"] = "internal review submitted";
  Events2["PreOnboardingForReinstallsClick"] = "pre-onboarding for reinstalls click";
  Events2["AIChatStarted"] = "ai chat started";
  Events2["AIResponseFeedback"] = "ai response feedback";
  Events2["AISessionSummary"] = "ai session summary";
  Events2["AIWidgetCreated"] = "ai widget created";
  Events2["AIWidgetUpdated"] = "ai widget updated";
  Events2["AIErrorOccurred"] = "ai error occurred";
  Events2["AnnualPlanRenewed"] = "annual plan renewed";
  Events2["AnnualOfferExpandedForTheFirstTime"] = "annual offer expanded for the first time";
  Events2["AnnualOfferClicked"] = "annual offer clicked";
  Events2["NewContactCreated"] = "new contact created";
  Events2["FlowBuilderFirstPageSelected"] = "flow builder- first page selected";
  Events2["ConditionCreated"] = "condition created";
  Events2["ConditionEdited"] = "condition edited";
  Events2["ConditionDeleted"] = "condition deleted";
  Events2["OrderSettingsChanged"] = "order settings changed";
  Events2["PostPurchaseAppUpdated"] = "post purchase app updated";
  Events2["StorePlanChanged"] = "store plan changed";
  Events2["BlockCreated"] = "block created";
  Events2["BlockEdited"] = "block edited";
  Events2["BlockDeleted"] = "block deleted";
  Events2["PaymentFailed"] = "payment failed";
  Events2["AdvertisementStatusChanged"] = "advertisement status changed";
  Events2["AdsBlockPlacementChanged"] = "ads block placement changed";
  Events2["BlockStatusChange"] = "block status change";
  Events2["AppActivated"] = "app activated";
  Events2["AppDeactivated"] = "app deactivated";
  Events2["ShopifyMetaObject"] = "event shopify metaobject";
  return Events2;
})(Events || {});
var KNOWN_EVENT_TOPICS = [
  "event_identity",
  "event_new_account",
  "event_app_installed",
  "event_app_uninstalled",
  "event_payment_approved",
  "event_app_enabled",
  "event_app_disabled",
  "event_payment_received",
  "event_store_details_changed",
  "event_pre_payment_next_click",
  "event_onboarding_started",
  "event_onboarding_welcome_page_click",
  "event_onboarding_go_to_dashboard_click",
  "event_onboarding_widget_type_page_view",
  "event_onboarding_widget_type_selected",
  "event_onboarding_max_discount_page_view",
  "event_onboarding_max_discount_selected",
  "event_onboarding_setup_page_view",
  "event_onboarding_setup_page_internal_click",
  "event_onboarding_setup_page_next_click",
  "event_onboarding_extension_page_view",
  "event_onboarding_extension_page_click",
  "event_onboarding_try_extension_setup_click",
  "event_extension_installed",
  "event_extension_panel_opened",
  "event_extension_launch_click",
  "event_extension_page_setup_result",
  "event_extension_setup_completed",
  "event_extension_go_to_dashboard_click",
  "event_shopify_editor_banner_click",
  "event_back_to_onboarding_from_dashboard",
  "event_page_activated",
  "event_page_deactivated",
  "event_variant_created",
  "event_variant_edited",
  "event_variant_deleted",
  "event_new_conversion",
  "event_internal_review_collector_viewed",
  "event_internal_review_collector_clicked",
  "event_internal_review_submitted",
  "event_pre_onboarding_for_reinstalls_click",
  "event_ai_chat_started",
  "event_ai_response_feedback",
  "event_ai_session_summary",
  "event_ai_widget_created",
  "event_ai_widget_updated",
  "event_ai_error_occurred",
  "event_annual_plan_renewed",
  "event_annual_offer_expanded_for_the_first_time",
  "event_annual_offer_clicked",
  "event_new_contact_added",
  "event_flow_builder_first_page_selected",
  "event_condition_created",
  "event_condition_edited",
  "event_condition_deleted",
  "event_order_settings_changed",
  "event_post_purchase_app_updated",
  "event_store_plan_changed",
  "event_block_created",
  "event_block_edited",
  "event_block_deleted",
  "event_payment_failed",
  "event_advertisement_status_changed",
  "event_ads_block_placement_changed",
  "event_block_status_change",
  "event_app_activated",
  "event_app_deactivated",
  "event_shopify_metaobject"
];

// src/kafka/trait-names.ts
var KafkaTrait = /* @__PURE__ */ ((KafkaTrait2) => {
  KafkaTrait2["Email"] = "email";
  KafkaTrait2["IsInstalled"] = "is installed";
  KafkaTrait2["StoreUrl"] = "store url";
  KafkaTrait2["Country"] = "country";
  KafkaTrait2["MonthlyOrders"] = "monthly orders";
  KafkaTrait2["ShopifyPlan"] = "shopify plan";
  KafkaTrait2["PaymentStatus"] = "payment status";
  KafkaTrait2["AppActivationStatus"] = "app activation status";
  KafkaTrait2["StoreName"] = "store name";
  KafkaTrait2["UserId"] = "user id";
  KafkaTrait2["MaxDiscount"] = "max discount";
  KafkaTrait2["NumberOfVariantsWithSubscriptionsEnabled"] = "# of variants with subscriptions enabled";
  KafkaTrait2["InternalReviewRating"] = "internal review rating";
  KafkaTrait2["Platform"] = "platform";
  KafkaTrait2["ReconvertRoi"] = "reconvert roi";
  KafkaTrait2["MonthlyRevenueGenerated"] = "monthly revenue generated";
  KafkaTrait2["PaymentFrequency"] = "payment frequency";
  KafkaTrait2["AnnualTier"] = "annual tier";
  KafkaTrait2["EligibleForAutomaticAnnualOffer"] = "eligible for automatic annual offer";
  KafkaTrait2["AnnualSwitchType"] = "annual switch type";
  KafkaTrait2["ShopifyPlanDisplayName"] = "shopify plan display name";
  KafkaTrait2["OrderEditing"] = "order editing";
  KafkaTrait2["AppLanguage"] = "app language";
  KafkaTrait2["PostPurchaseStatus"] = "post purchase status";
  KafkaTrait2["MaxCap"] = "max cap";
  KafkaTrait2["Gclid"] = "gclid";
  KafkaTrait2["AdvertisementStatus"] = "advertisement status";
  KafkaTrait2["TotalPaidToUpsellCom"] = "total paid to upsell.com";
  KafkaTrait2["UpsellComPlanVersion"] = "upsell.com plan version";
  KafkaTrait2["PhoneNumber"] = "phone number";
  KafkaTrait2["FirstName"] = "first name";
  KafkaTrait2["LastName"] = "last name";
  KafkaTrait2["CommissionPercent"] = "commission %";
  KafkaTrait2["LastPaymentDate"] = "last payment date";
  KafkaTrait2["AdsBlockPlacement"] = "ads block placement";
  KafkaTrait2["StoreVerticalPrimary"] = "store vertical- primary";
  KafkaTrait2["StoreVerticalSecondary"] = "store vertical- secondary";
  KafkaTrait2["ProductPageActiveBlocks"] = "product page- active blocks";
  KafkaTrait2["ProductPageNonActiveBlocks"] = "product page- non active blocks";
  KafkaTrait2["CartPageActiveBlocks"] = "cart page- active blocks";
  KafkaTrait2["CartPageNonActiveBlocks"] = "cart page- non active blocks";
  KafkaTrait2["CheckoutPageActiveBlocks"] = "checkout page- active blocks";
  KafkaTrait2["CheckoutPageNonActiveBlocks"] = "checkout page- non active blocks";
  KafkaTrait2["CartDrawerStatus"] = "cart drawer status";
  KafkaTrait2["ThankYouPageActiveBlocks"] = "thank you page- active blocks";
  KafkaTrait2["ThankYouPageNonActiveBlocks"] = "thank you page- non active blocks";
  KafkaTrait2["OrderStatusPageNonActiveBlocks"] = "order status page- non active blocks";
  KafkaTrait2["OrderStatusPageActiveBlocks"] = "order status page- active blocks";
  KafkaTrait2["AppStatus"] = "app status";
  KafkaTrait2["OnboardingFlow"] = "onboarding flow";
  KafkaTrait2["ExtensionInstalled"] = "extension installed";
  KafkaTrait2["ExtensionSetupStatus"] = "extension setup status";
  return KafkaTrait2;
})(KafkaTrait || {});

// src/kafka/property-names.ts
var KafkaEventProperty = /* @__PURE__ */ ((KafkaEventProperty2) => {
  KafkaEventProperty2["AcceptedOffers"] = "accepted offers";
  KafkaEventProperty2["ActionsTaken"] = "actions taken";
  KafkaEventProperty2["AdditionalFeedback"] = "additional feedback";
  KafkaEventProperty2["AdsEnabled"] = "ads enabled";
  KafkaEventProperty2["AdsRevenue"] = "ads revenue";
  KafkaEventProperty2["AffiliateId"] = "affiliate id";
  KafkaEventProperty2["AnnualTier"] = "annual tier";
  KafkaEventProperty2["Attempt"] = "attempt";
  KafkaEventProperty2["AssistantMessagesCount"] = "assistant messages count";
  KafkaEventProperty2["AuthorizedItemsReserveTime"] = "authorized items reserve time";
  KafkaEventProperty2["Block"] = "block";
  KafkaEventProperty2["BlockId"] = "block id";
  KafkaEventProperty2["BlockName"] = "block name";
  KafkaEventProperty2["Bundle"] = "bundle";
  KafkaEventProperty2["ButtonClicked"] = "button clicked";
  KafkaEventProperty2["Browser"] = "browser";
  KafkaEventProperty2["CartDrawerSet"] = "cart drawer set";
  KafkaEventProperty2["CartPageSet"] = "cart page set";
  KafkaEventProperty2["ChangeType"] = "change type";
  KafkaEventProperty2["CheckoutSet"] = "checkout set";
  KafkaEventProperty2["CheckoutAvailable"] = "checkout available";
  KafkaEventProperty2["ChromeExtensionEligibility"] = "chrome extension eligibility";
  KafkaEventProperty2["CommissionPercent"] = "commission %";
  KafkaEventProperty2["CommissionSum"] = "commission sum";
  KafkaEventProperty2["Condition"] = "condition";
  KafkaEventProperty2["ConditionCategory"] = "condition category";
  KafkaEventProperty2["ConditionId"] = "condition id";
  KafkaEventProperty2["ConditionName"] = "condition name";
  KafkaEventProperty2["ContactEmails"] = "contact emails";
  KafkaEventProperty2["ContactFullName"] = "contact full name";
  KafkaEventProperty2["ContactPhone"] = "contact phone";
  KafkaEventProperty2["ConversationId"] = "conversation id";
  KafkaEventProperty2["Country"] = "country";
  KafkaEventProperty2["CreationSource"] = "creation source";
  KafkaEventProperty2["CreationType"] = "creation type";
  KafkaEventProperty2["Currency"] = "currency";
  KafkaEventProperty2["DateAndTime"] = "date & time";
  KafkaEventProperty2["DeleteSource"] = "delete source";
  KafkaEventProperty2["DeletionType"] = "deletion type";
  KafkaEventProperty2["DestinationUrl"] = "destination url";
  KafkaEventProperty2["Device"] = "device";
  KafkaEventProperty2["DiscountPercent"] = "discount (%)";
  KafkaEventProperty2["DiscountValueUsd"] = "discount value ($)";
  KafkaEventProperty2["DiscountValuePercent"] = "discount value (%)";
  KafkaEventProperty2["Duration"] = "duration";
  KafkaEventProperty2["DontShowItAgainStatus"] = "don't show it again status";
  KafkaEventProperty2["EditingType"] = "editing type";
  KafkaEventProperty2["EditSource"] = "edit source";
  KafkaEventProperty2["Email"] = "email";
  KafkaEventProperty2["EndedWithSuccess"] = "ended with success";
  KafkaEventProperty2["EnterprisePricing"] = "enterprise pricing";
  KafkaEventProperty2["EntryBlockName"] = "entry block name";
  KafkaEventProperty2["EntryPage"] = "entry page";
  KafkaEventProperty2["ExtensionAlreadyInstalled"] = "extension already installed";
  KafkaEventProperty2["ExtensionVersion"] = "extension version";
  KafkaEventProperty2["FirstPage"] = "first page";
  KafkaEventProperty2["ErrorType"] = "error type";
  KafkaEventProperty2["FailureReason"] = "failure reason";
  KafkaEventProperty2["FalconAdsRevenue"] = "falcon ads revenue";
  KafkaEventProperty2["FeedbackFreeText"] = "feedback free text";
  KafkaEventProperty2["FeedbackReasons"] = "feedback reasons";
  KafkaEventProperty2["FeedbackType"] = "feedback type";
  KafkaEventProperty2["FirstName"] = "first name";
  KafkaEventProperty2["Frequency"] = "frequency";
  KafkaEventProperty2["Gclid"] = "gclid";
  KafkaEventProperty2["HandleFulfilledOrders"] = "handle fulfilled orders";
  KafkaEventProperty2["HandleManualPaymentMethods"] = "handle manual payment methods";
  KafkaEventProperty2["IsBlockEnabled"] = "is block enabled";
  KafkaEventProperty2["IsBlockPlaced"] = "is block placed";
  KafkaEventProperty2["IsTest"] = "is test";
  KafkaEventProperty2["Label"] = "label";
  KafkaEventProperty2["LastName"] = "last name";
  KafkaEventProperty2["Location"] = "location";
  KafkaEventProperty2["LoggedIntoShopify"] = "logged into shopify";
  KafkaEventProperty2["MaxCap"] = "max cap";
  KafkaEventProperty2["MaxDiscount"] = "max discount";
  KafkaEventProperty2["MessagesCount"] = "messages count";
  KafkaEventProperty2["MonthlyOrders"] = "monthly orders";
  KafkaEventProperty2["NewBlockPlacement"] = "new block placement";
  KafkaEventProperty2["NewPlacementStatus"] = "new placement status";
  KafkaEventProperty2["NewPlanDisplayName"] = "new plan display name";
  KafkaEventProperty2["NewPlanName"] = "new plan name";
  KafkaEventProperty2["NewPostPurchaseApp"] = "new post purchase app";
  KafkaEventProperty2["NewPropertyValue"] = "new property value";
  KafkaEventProperty2["NewStatus"] = "new status";
  KafkaEventProperty2["NumberOfPagesSet"] = "number of pages set";
  KafkaEventProperty2["NumberOfVariantsInTheBlock"] = "number of variants in the block";
  KafkaEventProperty2["OnboardingFlow"] = "onboarding flow";
  KafkaEventProperty2["OldPropertyValue"] = "old property value";
  KafkaEventProperty2["OnlyChargeForDisplayedOrders"] = "only charge for displayed orders";
  KafkaEventProperty2["OrderStatusPageSet"] = "order status page set";
  KafkaEventProperty2["OrderSumInOriginalCurrency"] = "order sum in original currency";
  KafkaEventProperty2["OrderSumInUsd"] = "order sum in usd";
  KafkaEventProperty2["Page"] = "page";
  KafkaEventProperty2["PageClicked"] = "page clicked";
  KafkaEventProperty2["PageType"] = "page type";
  KafkaEventProperty2["PagesFailed"] = "pages failed";
  KafkaEventProperty2["PagesFailedList"] = "pages failed list";
  KafkaEventProperty2["PagesInstalled"] = "pages installed";
  KafkaEventProperty2["PagesSelected"] = "pages selected";
  KafkaEventProperty2["PagesSelectedCount"] = "pages selected count";
  KafkaEventProperty2["PagesEdited"] = "pages edited";
  KafkaEventProperty2["PaidItemsReserveTime"] = "paid items reserve time";
  KafkaEventProperty2["PhoneNumber"] = "phone number";
  KafkaEventProperty2["Platform"] = "platform";
  KafkaEventProperty2["PostPurchaseAppSet"] = "post purchase app set";
  KafkaEventProperty2["PostPurchaseSet"] = "post purchase set";
  KafkaEventProperty2["PreviousBlockPlacement"] = "previous block placement";
  KafkaEventProperty2["PreviousPlacementStatus"] = "previous placement status";
  KafkaEventProperty2["PreviousPlanDisplayName"] = "previous plan display name";
  KafkaEventProperty2["PreviousPlanName"] = "previous plan name";
  KafkaEventProperty2["PreviousPostPurchaseApp"] = "previous post purchase app";
  KafkaEventProperty2["PreviousStatus"] = "previous status";
  KafkaEventProperty2["ProductPageSet"] = "product page set";
  KafkaEventProperty2["ProductRecommendation"] = "product recommendation";
  KafkaEventProperty2["ProductToDisplay"] = "product to display";
  KafkaEventProperty2["ProductUpsell"] = "product upsell";
  KafkaEventProperty2["PropertyChanged"] = "property changed";
  KafkaEventProperty2["PurchaseType"] = "purchase type";
  KafkaEventProperty2["Revenue"] = "revenue";
  KafkaEventProperty2["RevenueGeneratedByAds"] = "revenue generated by ads";
  KafkaEventProperty2["RevenueGeneratedByUpsell"] = "revenue generated by upsell";
  KafkaEventProperty2["Reinstall"] = "reinstall";
  KafkaEventProperty2["ReviewValue"] = "review value";
  KafkaEventProperty2["SequenceNumberOfTheRenewal"] = "sequence number of the renewal";
  KafkaEventProperty2["SessionDurationInSeconds"] = "session duration in seconds";
  KafkaEventProperty2["ShopifyPlan"] = "shopify plan";
  KafkaEventProperty2["SelectedByMerchant"] = "selected by merchant";
  KafkaEventProperty2["SelectedStoreUrl"] = "selected store url";
  KafkaEventProperty2["SetupStatus"] = "setup status";
  KafkaEventProperty2["Status"] = "status";
  KafkaEventProperty2["Step"] = "step";
  KafkaEventProperty2["StoreAdsDiscount"] = "store ads discount";
  KafkaEventProperty2["StoreName"] = "store name";
  KafkaEventProperty2["StoreUrl"] = "store url";
  KafkaEventProperty2["StoreVertical"] = "store vertical";
  KafkaEventProperty2["SubscriptionOptions"] = "subscription options";
  KafkaEventProperty2["SupportTicketOpened"] = "support ticket opened";
  KafkaEventProperty2["ThankYouPageSet"] = "thank you page set";
  KafkaEventProperty2["TimeSinceOriginalOrder"] = "time since original order";
  KafkaEventProperty2["TimeToCreateInMs"] = "time to create in ms";
  KafkaEventProperty2["TimerTime"] = "timer time";
  KafkaEventProperty2["ToolsUsedCount"] = "tools used count";
  KafkaEventProperty2["Trigger"] = "trigger";
  KafkaEventProperty2["TrialEndDate"] = "trial end date";
  KafkaEventProperty2["Type"] = "type";
  KafkaEventProperty2["UpdateRequestText"] = "update request text";
  KafkaEventProperty2["UpdateSuccessful"] = "update successful";
  KafkaEventProperty2["UpdateType"] = "update type";
  KafkaEventProperty2["UpsellComPlanVersion"] = "upsell.com plan version";
  KafkaEventProperty2["UptickAdsRevenue"] = "uptick ads revenue";
  KafkaEventProperty2["UserId"] = "user id";
  KafkaEventProperty2["UserMessagesCount"] = "user messages count";
  KafkaEventProperty2["Utms"] = "utms";
  KafkaEventProperty2["VariantId"] = "variant id";
  KafkaEventProperty2["VariantName"] = "variant name";
  KafkaEventProperty2["Widget"] = "widget";
  KafkaEventProperty2["WidgetId"] = "widget id";
  KafkaEventProperty2["WidgetLocation"] = "widget location";
  KafkaEventProperty2["WidgetName"] = "widget name";
  KafkaEventProperty2["WidgetType"] = "widget type";
  KafkaEventProperty2["WidgetTypes"] = "widget types";
  KafkaEventProperty2["Widgets"] = "widgets";
  KafkaEventProperty2["WidgetsCreatedCount"] = "widgets created count";
  KafkaEventProperty2["WidgetsUpdatedCount"] = "widgets updated count";
  return KafkaEventProperty2;
})(KafkaEventProperty || {});

// src/kafka/event-properties.ts
var EVENT_PROPERTY_MAP = {
  ["event_identity" /* Identity */]: [],
  ["new account" /* NewAccount */]: [
    "user id" /* UserId */,
    "affiliate id" /* AffiliateId */,
    "platform" /* Platform */,
    "date & time" /* DateAndTime */,
    "store name" /* StoreName */,
    "store url" /* StoreUrl */,
    "type" /* Type */,
    "utms" /* Utms */,
    "gclid" /* Gclid */
  ],
  ["app installed" /* AppInstalled */]: [
    "user id" /* UserId */,
    "date & time" /* DateAndTime */,
    "store name" /* StoreName */,
    "platform" /* Platform */,
    "store url" /* StoreUrl */,
    "first name" /* FirstName */,
    "last name" /* LastName */,
    "monthly orders" /* MonthlyOrders */,
    "shopify plan" /* ShopifyPlan */,
    "email" /* Email */,
    "phone number" /* PhoneNumber */,
    "country" /* Country */,
    "affiliate id" /* AffiliateId */,
    "label" /* Label */,
    "upsell.com plan version" /* UpsellComPlanVersion */,
    "utms" /* Utms */,
    "gclid" /* Gclid */,
    "store vertical" /* StoreVertical */
  ],
  ["app uninstalled" /* AppUninstalled */]: [
    "user id" /* UserId */,
    "date & time" /* DateAndTime */,
    "store url" /* StoreUrl */,
    "email" /* Email */,
    "utms" /* Utms */,
    "gclid" /* Gclid */
  ],
  ["payment approved" /* PaymentApproved */]: [
    "user id" /* UserId */,
    "date & time" /* DateAndTime */,
    "store url" /* StoreUrl */,
    "email" /* Email */,
    "affiliate id" /* AffiliateId */,
    "enterprise pricing" /* EnterprisePricing */,
    "discount (%)" /* DiscountPercent */,
    "trial end date" /* TrialEndDate */,
    "only charge for displayed orders" /* OnlyChargeForDisplayedOrders */,
    "frequency" /* Frequency */,
    "ads enabled" /* AdsEnabled */,
    "commission %" /* CommissionPercent */,
    "utms" /* Utms */,
    "gclid" /* Gclid */,
    "store vertical" /* StoreVertical */,
    "max cap" /* MaxCap */
  ],
  ["app enabled" /* AppEnabled */]: [
    "user id" /* UserId */,
    "store url" /* StoreUrl */,
    "email" /* Email */,
    "platform" /* Platform */,
    "location" /* Location */,
    "utms" /* Utms */,
    "gclid" /* Gclid */,
    "store vertical" /* StoreVertical */
  ],
  ["app disabled" /* AppDisabled */]: [
    "user id" /* UserId */,
    "store url" /* StoreUrl */,
    "email" /* Email */,
    "platform" /* Platform */,
    "utms" /* Utms */,
    "gclid" /* Gclid */
  ],
  ["payment received" /* PaymentReceived */]: [
    "user id" /* UserId */,
    "date & time" /* DateAndTime */,
    "platform" /* Platform */,
    "store url" /* StoreUrl */,
    "revenue" /* Revenue */,
    "frequency" /* Frequency */,
    "commission sum" /* CommissionSum */,
    "monthly orders" /* MonthlyOrders */,
    "accepted offers" /* AcceptedOffers */,
    "revenue generated by upsell" /* RevenueGeneratedByUpsell */,
    "email" /* Email */,
    "affiliate id" /* AffiliateId */,
    "utms" /* Utms */,
    "gclid" /* Gclid */,
    "store ads discount" /* StoreAdsDiscount */,
    "falcon ads revenue" /* FalconAdsRevenue */,
    "uptick ads revenue" /* UptickAdsRevenue */,
    "ads revenue" /* AdsRevenue */,
    "is test" /* IsTest */
  ],
  ["store details changed" /* StoreDetailsChanged */]: [
    "user id" /* UserId */,
    "store url" /* StoreUrl */,
    "email" /* Email */,
    "platform" /* Platform */,
    "property changed" /* PropertyChanged */,
    "old property value" /* OldPropertyValue */,
    "new property value" /* NewPropertyValue */
  ],
  ["pre-payment: next click" /* PrePaymentNextClick */]: [
    "user id" /* UserId */,
    "platform" /* Platform */,
    "date & time" /* DateAndTime */,
    "email" /* Email */,
    "store name" /* StoreName */,
    "store url" /* StoreUrl */,
    "monthly orders" /* MonthlyOrders */
  ],
  ["onboarding started" /* OnboardingStarted */]: [
    "user id" /* UserId */,
    "date & time" /* DateAndTime */,
    "store url" /* StoreUrl */,
    "email" /* Email */,
    "platform" /* Platform */,
    "chrome extension eligibility" /* ChromeExtensionEligibility */,
    "first page" /* FirstPage */,
    "browser" /* Browser */,
    "device" /* Device */
  ],
  ["onboarding: welcome page click" /* OnboardingWelcomePageClick */]: [
    "user id" /* UserId */,
    "store url" /* StoreUrl */,
    "email" /* Email */,
    "platform" /* Platform */,
    "button clicked" /* ButtonClicked */
  ],
  ["onboarding: go to dashboard click" /* OnboardingGoToDashboardClick */]: [
    "user id" /* UserId */,
    "store url" /* StoreUrl */,
    "email" /* Email */,
    "platform" /* Platform */,
    "number of pages set" /* NumberOfPagesSet */,
    "cart page set" /* CartPageSet */,
    "cart drawer set" /* CartDrawerSet */,
    "checkout set" /* CheckoutSet */,
    "product page set" /* ProductPageSet */,
    "post purchase set" /* PostPurchaseSet */,
    "thank you page set" /* ThankYouPageSet */,
    "order status page set" /* OrderStatusPageSet */
  ],
  ["onboarding: widget type page view" /* OnboardingWidgetTypePageView */]: [
    "user id" /* UserId */,
    "store url" /* StoreUrl */,
    "email" /* Email */,
    "platform" /* Platform */,
    "page" /* Page */
  ],
  ["onboarding: widget type selected" /* OnboardingWidgetTypeSelected */]: [
    "user id" /* UserId */,
    "store url" /* StoreUrl */,
    "email" /* Email */,
    "platform" /* Platform */,
    "page" /* Page */,
    "product upsell" /* ProductUpsell */,
    "bundle" /* Bundle */,
    "product recommendation" /* ProductRecommendation */
  ],
  ["onboarding: max discount page view" /* OnboardingMaxDiscountPageView */]: [
    "user id" /* UserId */,
    "store url" /* StoreUrl */,
    "email" /* Email */,
    "platform" /* Platform */
  ],
  ["onboarding: max discount selected" /* OnboardingMaxDiscountSelected */]: [
    "user id" /* UserId */,
    "store url" /* StoreUrl */,
    "email" /* Email */,
    "platform" /* Platform */,
    "max discount" /* MaxDiscount */,
    "onboarding flow" /* OnboardingFlow */
  ],
  ["onboarding: setup page view" /* OnboardingSetupPageView */]: [
    "user id" /* UserId */,
    "store url" /* StoreUrl */,
    "email" /* Email */,
    "platform" /* Platform */,
    "page" /* Page */
  ],
  ["onboarding: setup page internal click" /* OnboardingSetupPageInternalClick */]: [
    "user id" /* UserId */,
    "store url" /* StoreUrl */,
    "email" /* Email */,
    "platform" /* Platform */,
    "page" /* Page */,
    "button clicked" /* ButtonClicked */
  ],
  ["onboarding: setup page next click" /* OnboardingSetupPageNextClick */]: [
    "user id" /* UserId */,
    "store url" /* StoreUrl */,
    "email" /* Email */,
    "platform" /* Platform */,
    "max discount" /* MaxDiscount */,
    "page" /* Page */
  ],
  ["onboarding: extension page view" /* OnboardingExtensionPageView */]: [
    "user id" /* UserId */,
    "date & time" /* DateAndTime */,
    "store url" /* StoreUrl */,
    "email" /* Email */,
    "platform" /* Platform */,
    "extension already installed" /* ExtensionAlreadyInstalled */
  ],
  ["onboarding: extension page click" /* OnboardingExtensionPageClick */]: [
    "user id" /* UserId */,
    "date & time" /* DateAndTime */,
    "store url" /* StoreUrl */,
    "email" /* Email */,
    "platform" /* Platform */,
    "button clicked" /* ButtonClicked */,
    "extension already installed" /* ExtensionAlreadyInstalled */
  ],
  ["onboarding: try extension setup click" /* OnboardingTryExtensionSetupClick */]: [
    "user id" /* UserId */,
    "date & time" /* DateAndTime */,
    "store url" /* StoreUrl */,
    "email" /* Email */,
    "platform" /* Platform */,
    "page" /* Page */
  ],
  ["extension installed" /* OnboardingExtensionInstalled */]: [
    "user id" /* UserId */,
    "date & time" /* DateAndTime */,
    "store url" /* StoreUrl */,
    "email" /* Email */,
    "platform" /* Platform */,
    "extension version" /* ExtensionVersion */,
    "reinstall" /* Reinstall */
  ],
  ["extension panel opened" /* OnboardingExtensionPanelOpened */]: [
    "user id" /* UserId */,
    "date & time" /* DateAndTime */,
    "store url" /* StoreUrl */,
    "email" /* Email */,
    "platform" /* Platform */,
    "trigger" /* Trigger */,
    "setup status" /* SetupStatus */,
    "logged into shopify" /* LoggedIntoShopify */
  ],
  ["extension launch click" /* OnboardingExtensionLaunchClick */]: [
    "user id" /* UserId */,
    "date & time" /* DateAndTime */,
    "store url" /* StoreUrl */,
    "email" /* Email */,
    "platform" /* Platform */,
    "selected store url" /* SelectedStoreUrl */,
    "max discount" /* MaxDiscount */,
    "pages selected" /* PagesSelected */,
    "pages selected count" /* PagesSelectedCount */,
    "checkout available" /* CheckoutAvailable */,
    "ads enabled" /* AdsEnabled */
  ],
  ["extension page setup result" /* OnboardingExtensionPageSetupResult */]: [
    "user id" /* UserId */,
    "date & time" /* DateAndTime */,
    "store url" /* StoreUrl */,
    "email" /* Email */,
    "platform" /* Platform */,
    "page" /* Page */,
    "selected by merchant" /* SelectedByMerchant */,
    "status" /* Status */,
    "failure reason" /* FailureReason */,
    "attempt" /* Attempt */,
    "duration" /* Duration */
  ],
  ["extension setup completed" /* OnboardingExtensionSetupCompleted */]: [
    "user id" /* UserId */,
    "date & time" /* DateAndTime */,
    "store url" /* StoreUrl */,
    "email" /* Email */,
    "platform" /* Platform */,
    "pages installed" /* PagesInstalled */,
    "pages failed" /* PagesFailed */,
    "pages failed list" /* PagesFailedList */,
    "duration" /* Duration */,
    "post purchase app set" /* PostPurchaseAppSet */
  ],
  ["extension go to dashboard click" /* OnboardingExtensionGoToDashboardClick */]: [
    "user id" /* UserId */,
    "date & time" /* DateAndTime */,
    "store url" /* StoreUrl */,
    "email" /* Email */,
    "platform" /* Platform */,
    "pages installed" /* PagesInstalled */,
    "pages failed" /* PagesFailed */
  ],
  ["shopify editor banner click" /* ShopifyEditorBannerClick */]: [
    "user id" /* UserId */,
    "store url" /* StoreUrl */,
    "email" /* Email */,
    "platform" /* Platform */,
    "page" /* Page */,
    "button clicked" /* ButtonClicked */
  ],
  ["back to onboarding from dashboard" /* BackToOnboardingFromDashboard */]: [
    "user id" /* UserId */,
    "store url" /* StoreUrl */,
    "email" /* Email */,
    "platform" /* Platform */,
    "page" /* Page */
  ],
  ["page activated" /* PageActivated */]: [
    "user id" /* UserId */,
    "store url" /* StoreUrl */,
    "email" /* Email */,
    "platform" /* Platform */,
    "page" /* Page */,
    "location" /* Location */
  ],
  ["page deactivated" /* PageDeactivated */]: [
    "user id" /* UserId */,
    "store url" /* StoreUrl */,
    "email" /* Email */,
    "platform" /* Platform */,
    "page" /* Page */,
    "location" /* Location */
  ],
  ["variant created" /* VariantCreated */]: [
    "user id" /* UserId */,
    "store url" /* StoreUrl */,
    "email" /* Email */,
    "platform" /* Platform */,
    "page" /* Page */,
    "condition name" /* ConditionName */,
    "condition id" /* ConditionId */,
    "block" /* Block */,
    "block name" /* BlockName */,
    "block id" /* BlockId */,
    "variant name" /* VariantName */,
    "variant id" /* VariantId */,
    "widget types" /* WidgetTypes */,
    "status" /* Status */
  ],
  ["variant edited" /* VariantEdited */]: [
    "user id" /* UserId */,
    "store url" /* StoreUrl */,
    "email" /* Email */,
    "platform" /* Platform */,
    "page" /* Page */,
    "condition name" /* ConditionName */,
    "condition id" /* ConditionId */,
    "block" /* Block */,
    "block name" /* BlockName */,
    "block id" /* BlockId */,
    "variant name" /* VariantName */,
    "variant id" /* VariantId */,
    "widget types" /* WidgetTypes */,
    "status" /* Status */,
    "change type" /* ChangeType */
  ],
  ["variant deleted" /* VariantDeleted */]: [
    "user id" /* UserId */,
    "store url" /* StoreUrl */,
    "email" /* Email */,
    "page" /* Page */,
    "condition name" /* ConditionName */,
    "condition id" /* ConditionId */,
    "block" /* Block */,
    "block name" /* BlockName */,
    "block id" /* BlockId */,
    "variant name" /* VariantName */,
    "variant id" /* VariantId */,
    "widget types" /* WidgetTypes */,
    "status" /* Status */
  ],
  ["new conversion" /* NewConversion */]: [
    "user id" /* UserId */,
    "date & time" /* DateAndTime */,
    "email" /* Email */,
    "store url" /* StoreUrl */,
    "widget" /* Widget */,
    "order sum in original currency" /* OrderSumInOriginalCurrency */,
    "order sum in usd" /* OrderSumInUsd */,
    "currency" /* Currency */,
    "page" /* Page */,
    "block name" /* BlockName */,
    "condition category" /* ConditionCategory */,
    "type" /* Type */,
    "time since original order" /* TimeSinceOriginalOrder */,
    "discount value (%)" /* DiscountValuePercent */,
    "discount value ($)" /* DiscountValueUsd */,
    "device" /* Device */,
    "timer time" /* TimerTime */,
    "product to display" /* ProductToDisplay */,
    "subscription options" /* SubscriptionOptions */,
    "purchase type" /* PurchaseType */
  ],
  ["internal review collector viewed" /* InternalReviewCollectorViewed */]: [
    "user id" /* UserId */,
    "store url" /* StoreUrl */,
    "review value" /* ReviewValue */,
    "widget location" /* WidgetLocation */
  ],
  ["internal review collector clicked" /* InternalReviewCollectorClicked */]: [
    "user id" /* UserId */,
    "store url" /* StoreUrl */,
    "review value" /* ReviewValue */,
    "widget location" /* WidgetLocation */
  ],
  ["internal review submitted" /* InternalReviewSubmitted */]: [
    "user id" /* UserId */,
    "store url" /* StoreUrl */,
    "review value" /* ReviewValue */,
    "widget location" /* WidgetLocation */,
    "additional feedback" /* AdditionalFeedback */
  ],
  ["pre-onboarding for reinstalls click" /* PreOnboardingForReinstallsClick */]: [
    "store url" /* StoreUrl */,
    "user id" /* UserId */,
    "email" /* Email */,
    "platform" /* Platform */,
    "button clicked" /* ButtonClicked */
  ],
  ["ai chat started" /* AIChatStarted */]: [
    "store url" /* StoreUrl */,
    "conversation id" /* ConversationId */,
    "user id" /* UserId */,
    "email" /* Email */,
    "entry page" /* EntryPage */,
    "entry block name" /* EntryBlockName */
  ],
  ["ai response feedback" /* AIResponseFeedback */]: [
    "store url" /* StoreUrl */,
    "conversation id" /* ConversationId */,
    "user id" /* UserId */,
    "email" /* Email */,
    "feedback type" /* FeedbackType */,
    "feedback reasons" /* FeedbackReasons */,
    "feedback free text" /* FeedbackFreeText */
  ],
  ["ai session summary" /* AISessionSummary */]: [
    "store url" /* StoreUrl */,
    "conversation id" /* ConversationId */,
    "user id" /* UserId */,
    "email" /* Email */,
    "messages count" /* MessagesCount */,
    "user messages count" /* UserMessagesCount */,
    "assistant messages count" /* AssistantMessagesCount */,
    "tools used count" /* ToolsUsedCount */,
    "widgets created count" /* WidgetsCreatedCount */,
    "widgets updated count" /* WidgetsUpdatedCount */,
    "pages edited" /* PagesEdited */,
    "session duration in seconds" /* SessionDurationInSeconds */,
    "ended with success" /* EndedWithSuccess */,
    "actions taken" /* ActionsTaken */
  ],
  ["ai widget created" /* AIWidgetCreated */]: [
    "store url" /* StoreUrl */,
    "conversation id" /* ConversationId */,
    "user id" /* UserId */,
    "email" /* Email */,
    "widget id" /* WidgetId */,
    "widget type" /* WidgetType */,
    "widget name" /* WidgetName */,
    "page" /* Page */,
    "block name" /* BlockName */,
    "time to create in ms" /* TimeToCreateInMs */
  ],
  ["ai widget updated" /* AIWidgetUpdated */]: [
    "store url" /* StoreUrl */,
    "conversation id" /* ConversationId */,
    "user id" /* UserId */,
    "email" /* Email */,
    "widget id" /* WidgetId */,
    "widget type" /* WidgetType */,
    "widget name" /* WidgetName */,
    "page" /* Page */,
    "block name" /* BlockName */,
    "update type" /* UpdateType */,
    "update request text" /* UpdateRequestText */,
    "update successful" /* UpdateSuccessful */
  ],
  ["ai error occurred" /* AIErrorOccurred */]: [
    "store url" /* StoreUrl */,
    "conversation id" /* ConversationId */,
    "user id" /* UserId */,
    "email" /* Email */,
    "error type" /* ErrorType */,
    "step" /* Step */,
    "support ticket opened" /* SupportTicketOpened */
  ],
  ["annual plan renewed" /* AnnualPlanRenewed */]: [
    "user id" /* UserId */,
    "date & time" /* DateAndTime */,
    "store url" /* StoreUrl */,
    "email" /* Email */,
    "affiliate id" /* AffiliateId */,
    "annual tier" /* AnnualTier */,
    "sequence number of the renewal" /* SequenceNumberOfTheRenewal */,
    "revenue" /* Revenue */
  ],
  ["annual offer expanded for the first time" /* AnnualOfferExpandedForTheFirstTime */]: [
    "user id" /* UserId */,
    "date & time" /* DateAndTime */,
    "store url" /* StoreUrl */,
    "email" /* Email */,
    "affiliate id" /* AffiliateId */,
    "annual tier" /* AnnualTier */,
    "monthly orders" /* MonthlyOrders */,
    "revenue generated by upsell" /* RevenueGeneratedByUpsell */
  ],
  ["annual offer clicked" /* AnnualOfferClicked */]: [
    "user id" /* UserId */,
    "date & time" /* DateAndTime */,
    "store url" /* StoreUrl */,
    "email" /* Email */,
    "affiliate id" /* AffiliateId */,
    "location" /* Location */,
    "button clicked" /* ButtonClicked */,
    "don't show it again status" /* DontShowItAgainStatus */
  ],
  ["new contact created" /* NewContactCreated */]: [
    "user id" /* UserId */,
    "date & time" /* DateAndTime */,
    "store url" /* StoreUrl */,
    "email" /* Email */,
    "contact full name" /* ContactFullName */,
    "contact emails" /* ContactEmails */,
    "contact phone" /* ContactPhone */
  ],
  ["flow builder- first page selected" /* FlowBuilderFirstPageSelected */]: [
    "user id" /* UserId */,
    "date & time" /* DateAndTime */,
    "store name" /* StoreName */,
    "platform" /* Platform */,
    "store url" /* StoreUrl */,
    "page clicked" /* PageClicked */
  ],
  ["condition created" /* ConditionCreated */]: [
    "user id" /* UserId */,
    "store url" /* StoreUrl */,
    "email" /* Email */,
    "platform" /* Platform */,
    "page" /* Page */,
    "condition" /* Condition */,
    "condition name" /* ConditionName */,
    "condition id" /* ConditionId */,
    "status" /* Status */,
    "creation source" /* CreationSource */,
    "conversation id" /* ConversationId */
  ],
  ["condition edited" /* ConditionEdited */]: [
    "user id" /* UserId */,
    "store url" /* StoreUrl */,
    "email" /* Email */,
    "page" /* Page */,
    "condition" /* Condition */,
    "condition name" /* ConditionName */,
    "condition id" /* ConditionId */,
    "status" /* Status */,
    "change type" /* ChangeType */,
    "edit source" /* EditSource */,
    "conversation id" /* ConversationId */
  ],
  ["condition deleted" /* ConditionDeleted */]: [
    "user id" /* UserId */,
    "store url" /* StoreUrl */,
    "email" /* Email */,
    "page" /* Page */,
    "condition" /* Condition */,
    "condition name" /* ConditionName */,
    "condition id" /* ConditionId */,
    "status" /* Status */,
    "delete source" /* DeleteSource */,
    "conversation id" /* ConversationId */
  ],
  ["order settings changed" /* OrderSettingsChanged */]: [
    "status" /* Status */,
    "widgets" /* Widgets */,
    "paid items reserve time" /* PaidItemsReserveTime */,
    "authorized items reserve time" /* AuthorizedItemsReserveTime */,
    "handle fulfilled orders" /* HandleFulfilledOrders */,
    "handle manual payment methods" /* HandleManualPaymentMethods */,
    "email" /* Email */
  ],
  ["post purchase app updated" /* PostPurchaseAppUpdated */]: [
    "user id" /* UserId */,
    "date & time" /* DateAndTime */,
    "store url" /* StoreUrl */,
    "email" /* Email */,
    "previous post purchase app" /* PreviousPostPurchaseApp */,
    "new post purchase app" /* NewPostPurchaseApp */,
    "location" /* Location */
  ],
  ["store plan changed" /* StorePlanChanged */]: [
    "store url" /* StoreUrl */,
    "user id" /* UserId */,
    "email" /* Email */,
    "previous plan display name" /* PreviousPlanDisplayName */,
    "new plan display name" /* NewPlanDisplayName */,
    "previous plan name" /* PreviousPlanName */,
    "new plan name" /* NewPlanName */
  ],
  ["block created" /* BlockCreated */]: [
    "user id" /* UserId */,
    "store url" /* StoreUrl */,
    "email" /* Email */,
    "page" /* Page */,
    "condition name" /* ConditionName */,
    "condition id" /* ConditionId */,
    "block" /* Block */,
    "block name" /* BlockName */,
    "block id" /* BlockId */,
    "is block enabled" /* IsBlockEnabled */,
    "is block placed" /* IsBlockPlaced */,
    "number of variants in the block" /* NumberOfVariantsInTheBlock */,
    "creation type" /* CreationType */
  ],
  ["block edited" /* BlockEdited */]: [
    "user id" /* UserId */,
    "store url" /* StoreUrl */,
    "email" /* Email */,
    "page" /* Page */,
    "condition name" /* ConditionName */,
    "condition id" /* ConditionId */,
    "block" /* Block */,
    "block name" /* BlockName */,
    "block id" /* BlockId */,
    "is block enabled" /* IsBlockEnabled */,
    "is block placed" /* IsBlockPlaced */,
    "change type" /* ChangeType */,
    "editing type" /* EditingType */
  ],
  ["block deleted" /* BlockDeleted */]: [
    "user id" /* UserId */,
    "store url" /* StoreUrl */,
    "email" /* Email */,
    "page" /* Page */,
    "condition name" /* ConditionName */,
    "condition id" /* ConditionId */,
    "block" /* Block */,
    "block name" /* BlockName */,
    "block id" /* BlockId */,
    "is block enabled" /* IsBlockEnabled */,
    "is block placed" /* IsBlockPlaced */,
    "number of variants in the block" /* NumberOfVariantsInTheBlock */,
    "deletion type" /* DeletionType */
  ],
  ["payment failed" /* PaymentFailed */]: [
    "user id" /* UserId */,
    "date & time" /* DateAndTime */,
    "store url" /* StoreUrl */,
    "revenue" /* Revenue */,
    "frequency" /* Frequency */,
    "commission sum" /* CommissionSum */,
    "monthly orders" /* MonthlyOrders */,
    "revenue generated by upsell" /* RevenueGeneratedByUpsell */,
    "email" /* Email */,
    "utms" /* Utms */,
    "gclid" /* Gclid */,
    "revenue generated by ads" /* RevenueGeneratedByAds */,
    "store ads discount" /* StoreAdsDiscount */,
    "shopify plan" /* ShopifyPlan */,
    "failure reason" /* FailureReason */
  ],
  ["advertisement status changed" /* AdvertisementStatusChanged */]: [
    "user id" /* UserId */,
    "store url" /* StoreUrl */,
    "previous status" /* PreviousStatus */,
    "new status" /* NewStatus */
  ],
  ["ads block placement changed" /* AdsBlockPlacementChanged */]: [
    "user id" /* UserId */,
    "date & time" /* DateAndTime */,
    "store name" /* StoreName */,
    "email" /* Email */,
    "store url" /* StoreUrl */,
    "previous block placement" /* PreviousBlockPlacement */,
    "new block placement" /* NewBlockPlacement */
  ],
  ["block status change" /* BlockStatusChange */]: [
    "user id" /* UserId */,
    "store url" /* StoreUrl */,
    "email" /* Email */,
    "page" /* Page */,
    "block" /* Block */,
    "block name" /* BlockName */,
    "block id" /* BlockId */,
    "is block enabled" /* IsBlockEnabled */,
    "is block placed" /* IsBlockPlaced */,
    "previous status" /* PreviousStatus */,
    "new status" /* NewStatus */,
    "previous placement status" /* PreviousPlacementStatus */,
    "new placement status" /* NewPlacementStatus */,
    "location" /* Location */
  ],
  ["app activated" /* AppActivated */]: [
    "user id" /* UserId */,
    "store url" /* StoreUrl */,
    "email" /* Email */,
    "platform" /* Platform */
  ],
  ["app deactivated" /* AppDeactivated */]: [
    "user id" /* UserId */,
    "store url" /* StoreUrl */,
    "email" /* Email */,
    "platform" /* Platform */
  ],
  ["event shopify metaobject" /* ShopifyMetaObject */]: []
};
var KNOWN_EVENT_NAMES = new Set(Object.values(Events));
function getAllowedPropertiesForEvent(event) {
  if (!KNOWN_EVENT_NAMES.has(event)) {
    return null;
  }
  return new Set(EVENT_PROPERTY_MAP[event]);
}

// src/kafka/topics.ts
function toEventTopic(event) {
  return `event_${event.trim().toLowerCase().replace(/[^a-z0-9]+/g, "_").replace(/^_+|_+$/g, "")}`;
}
var TOPIC_OVERRIDES = {
  ["event_identity" /* Identity */]: "event_identity",
  ["new contact created" /* NewContactCreated */]: "event_new_contact_added",
  ["event shopify metaobject" /* ShopifyMetaObject */]: "event_shopify_metaobject"
};
function getEventTopic(event) {
  return TOPIC_OVERRIDES[event] ?? toEventTopic(event);
}
function buildTopicMap(events) {
  const map = {};
  for (const event of events) {
    map[event] = getEventTopic(event);
  }
  return map;
}
var EVENT_TOPIC_BY_EVENT = buildTopicMap(
  Object.values(Events)
);

// src/kafka/destinations.ts
var ALL_EVENTS = Object.values(Events);
var ANALYTICS_EVENTS = ALL_EVENTS.filter(
  (event) => event !== "event shopify metaobject" /* ShopifyMetaObject */
);
var MIXPANEL_EVENTS = ANALYTICS_EVENTS;
var PIPEDRIVE_EVENTS = [
  "new account" /* NewAccount */,
  "app installed" /* AppInstalled */,
  "app uninstalled" /* AppUninstalled */,
  "payment approved" /* PaymentApproved */,
  "app enabled" /* AppEnabled */,
  "app disabled" /* AppDisabled */,
  "payment received" /* PaymentReceived */,
  "store details changed" /* StoreDetailsChanged */,
  "new contact created" /* NewContactCreated */
];
var FACEBOOK_EVENTS = [
  "app installed" /* AppInstalled */,
  "payment approved" /* PaymentApproved */
];
var METAOBJECT_EVENTS = [
  "event shopify metaobject" /* ShopifyMetaObject */
];
var MIXPANEL_EVENT_TOPICS = buildTopicMap(MIXPANEL_EVENTS);
var PIPEDRIVE_TOPICS = buildTopicMap(PIPEDRIVE_EVENTS);
var FACEBOOK_TOPICS = buildTopicMap(FACEBOOK_EVENTS);
var METAOBJECT_TOPICS = buildTopicMap(METAOBJECT_EVENTS);

// src/kafka/context-keys.ts
var KafkaContextKey = /* @__PURE__ */ ((KafkaContextKey3) => {
  KafkaContextKey3["FacebookAdsParams"] = "facebookAdsParams";
  return KafkaContextKey3;
})(KafkaContextKey || {});

// src/kafka/utils.ts
var ALLOWED_TRAIT_KEYS = /* @__PURE__ */ new Set([
  ...Object.values(KafkaTrait)
]);
var ALLOWED_PROPERTY_KEYS = /* @__PURE__ */ new Set([
  ...Object.values(KafkaEventProperty)
]);
function parseEventContext(context) {
  if (context == null || context === "") {
    return {};
  }
  if (typeof context === "string") {
    try {
      const parsed = JSON.parse(context);
      return parsed && typeof parsed === "object" && !Array.isArray(parsed) ? parsed : {};
    } catch {
      return {};
    }
  }
  if (typeof context === "object" && !Array.isArray(context)) {
    return context;
  }
  return {};
}
function getContextField(context, key) {
  const parsed = parseEventContext(context);
  let value = parsed[key];
  if (value === void 0) {
    return void 0;
  }
  if (typeof value === "string") {
    try {
      value = JSON.parse(value);
    } catch {
    }
  }
  return value;
}
function normalizeTraits(traits, logDropped) {
  return filterKeysToAllowList(traits, ALLOWED_TRAIT_KEYS, logDropped);
}
function normalizeProperties(properties, logDropped, event) {
  const allowList = event != null && event !== "" ? getAllowedPropertiesForEvent(event) ?? ALLOWED_PROPERTY_KEYS : ALLOWED_PROPERTY_KEYS;
  return filterKeysToAllowList(properties, allowList, logDropped);
}
function filterKeysToAllowList(fields, allowList, logDropped) {
  if (!fields || typeof fields !== "object" || Array.isArray(fields)) {
    return fields;
  }
  const filtered = {};
  const dropped = [];
  for (const [key, value] of Object.entries(fields)) {
    if (allowList.has(key)) {
      filtered[key] = value;
    } else {
      dropped.push(key);
    }
  }
  if (dropped.length && typeof logDropped === "function") {
    logDropped(dropped);
  }
  return filtered;
}
export {
  ALLOWED_PROPERTY_KEYS,
  ALLOWED_TRAIT_KEYS,
  EVENT_PROPERTY_MAP,
  EVENT_TOPIC_BY_EVENT,
  Events,
  FACEBOOK_EVENTS,
  FACEBOOK_TOPICS,
  KNOWN_EVENT_NAMES,
  KNOWN_EVENT_TOPICS,
  KafkaContextKey,
  KafkaEventProperty,
  KafkaTrait,
  METAOBJECT_EVENTS,
  METAOBJECT_TOPICS,
  MIXPANEL_EVENTS,
  MIXPANEL_EVENT_TOPICS,
  PIPEDRIVE_EVENTS,
  PIPEDRIVE_TOPICS,
  getAllowedPropertiesForEvent,
  getContextField,
  getEventTopic,
  normalizeProperties,
  normalizeTraits,
  parseEventContext
};
//# sourceMappingURL=index.js.map